import { registry } from "../../../configs/registry";
import { ALLOW_RUNTIME_FEDERATION_VERSION_OVERLOADING, IS_RUNTIME_FEDERATION, } from "../../constants/environment";
import { updateUrlVersion } from "./updateUrlVersion";
export const getApplicationScriptUrl = ({ id, version, }) => {
    const baseUrl = id && registry.getApplicationFromId(id)?.urls.client;
    if (!baseUrl)
        return null;
    const runtimeVersion = ALLOW_RUNTIME_FEDERATION_VERSION_OVERLOADING
        ? version
        : undefined;
    return IS_RUNTIME_FEDERATION && runtimeVersion
        ? updateUrlVersion(baseUrl, runtimeVersion)
        : baseUrl;
};
